export default __webpack_public_path__ + "static/media/warning--bus-stop-ahead--g2.7fa78816.png";